import { ProductItem } from "hooks/ProductsManagement/useGetProductsQuery";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type OrderCartItem = ProductItem & {
  count: number;
};

interface OrderCartStore {
  cart: OrderCartItem[];
  setCart: (val: ProductItem) => void;
  removeCartItem: (id: string) => void;
  decreaseCartItem: (id: string) => void;
  clearCart: () => void;
  isInCart: (id: string) => boolean;
}

export const useOrderCartStore = create(
  persist<OrderCartStore>(
    (set, get) => ({
      cart: [],
      setCart: (cartItem) => {
        const cartItems = get().cart;
        const existingItem = cartItems.find((item) => item.id === cartItem.id);

        if (existingItem) {
          const updatedCart = cartItems.map((item) => {
            if (item.id === cartItem.id) {
              return {
                ...item,
                count: item.count + 1,
              };
            }

            return item;
          });

          set({
            cart: updatedCart,
          });

          return;
        }

        set((state) => ({
          cart: [...state.cart, { ...cartItem, count: 1 }],
        }));
      },
      removeCartItem: (cartItemId) => {
        set((state) => ({
          cart: state.cart.filter((item) => item.id !== cartItemId),
        }));
      },
      isInCart: (id: string) => {
        return get().cart.some((item) => item.id === id);
      },
      decreaseCartItem: (cartItemId) => {
        const cartItems = get().cart;
        const existingItem = cartItems.find((item) => item.id === cartItemId);

        if (existingItem) {
          if (existingItem.count === 1) {
            get().removeCartItem(existingItem.id);
          } else {
            const updatedCart = cartItems.map((item) => {
              if (item.id === cartItemId) {
                return {
                  ...item,
                  count: item.count - 1,
                };
              }
              return item;
            });
            set({
              cart: updatedCart,
            });
          }
          return;
        }
      },
      clearCart: () => {
        set({
          cart: [],
        });
      },
    }),
    {
      name: "manual_order_cart", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage),
      // merge: (persistedState, currentState) =>
      //   deepMerge(currentState, persistedState),
    }
  )
);
